module.exports = __webpack_public_path__ + "bb1938e9d98aa80d2c9838196af6a98c.pdf";